import { filterIssue, generatedId } from "./helper";

const sprintIssues = {
  name: "Sprint March 1",
  type: "sprint",
  id: generatedId(),
  objective: "Create an MVP for the review of stackholders",
  startDate: "",
  endDate: "",
  duration: "",
  noOfissues: 23,
  issues: [
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20743",
      key: "OD-69",
      fields: {
        summary: "Frontend UI for Cart Modification",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20741",
          key: "OD-67",
          fields: {
            summary: "Modify Cart Contents",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20742",
      key: "OD-68",
      fields: {
        summary: "Backend Logic for Cart Updates",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20741",
          key: "OD-67",
          fields: {
            summary: "Modify Cart Contents",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20750",
      key: "OD-76",
      fields: {
        summary: "Testing Coupon Application",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20749",
      key: "OD-75",
      fields: {
        summary: "Discount Calculation and Cart Update",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20748",
      key: "OD-74",
      fields: {
        summary: "Frontend UI for Coupon Application",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20747",
      key: "OD-73",
      fields: {
        summary: "Backend Validation for Coupons",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20756",
      key: "OD-82",
      fields: {
        summary: "Testing Payment Integration",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20755",
      key: "OD-81",
      fields: {
        summary: "Order Confirmation Page",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20754",
      key: "OD-80",
      fields: {
        summary: "Secure Payment Processing Backend",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20753",
      key: "OD-79",
      fields: {
        summary: "Frontend Payment Options UI",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20752",
      key: "OD-78",
      fields: {
        summary: "Integrate Payment Gateway APIs",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20761",
      key: "OD-87",
      fields: {
        summary: "Testing Tax and Shipping Calculation",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20760",
      key: "OD-86",
      fields: {
        summary: "Dynamic Fee Update on Address Change",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20759",
      key: "OD-85",
      fields: {
        summary: "Shipping Fee Calculation",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20758",
      key: "OD-84",
      fields: {
        summary: "Tax Calculation Logic",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20762",
      key: "OD-88",
      fields: {
        summary: "Order Management System",
        issuetype: {
          id: "20079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20763",
      key: "OD-89",
      fields: {
        summary: "Role-Based Access Control (Admin)",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "20762",
          key: "OD-88",
          fields: {
            summary: "Order Management System",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20767",
      key: "OD-93",
      fields: {
        summary: "Logging Admin Actions",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20766",
      key: "OD-92",
      fields: {
        summary: "Restrict Admin Panel Access",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20765",
      key: "OD-91",
      fields: {
        summary: "Create Admin Panel UI",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20764",
      key: "OD-90",
      fields: {
        summary: "Define Role Management Logic",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20768",
      key: "OD-94",
      fields: {
        summary: "Customer Feedback and Review System",
        issuetype: {
          id: "20079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20784",
      key: "OD-110",
      fields: {
        summary: "Review Analytics for Insights",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "20768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20779",
      key: "OD-105",
      fields: {
        summary: "Display Approved Reviews",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "20768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20774",
      key: "OD-100",
      fields: {
        summary: "Review Moderation by Admin",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "20768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20769",
      key: "OD-95",
      fields: {
        summary: "Customer Review Submission",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "20768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20773",
      key: "OD-99",
      fields: {
        summary: "Handle Review Confirmation and Error Messaging",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20772",
      key: "OD-98",
      fields: {
        summary: "Integrate Review System with Product Pages",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20771",
      key: "OD-97",
      fields: {
        summary: "Design and Implement Review Submission UI",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20770",
      key: "OD-96",
      fields: {
        summary: "Implement Review Submission Backend",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20778",
      key: "OD-104",
      fields: {
        summary: "Add Notification for Moderation Results",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20777",
      key: "OD-103",
      fields: {
        summary: "Integrate Moderation Actions with Logging System",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20776",
      key: "OD-102",
      fields: {
        summary: "Create Review Moderation UI",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20775",
      key: "OD-101",
      fields: {
        summary: "Implement Review Moderation Backend",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20783",
      key: "OD-109",
      fields: {
        summary: "Add Review Sorting Options",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20782",
      key: "OD-108",
      fields: {
        summary: "Integrate Backend API with Frontend for Review Display",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20781",
      key: "OD-107",
      fields: {
        summary: "Design Frontend UI for Review Display",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20780",
      key: "OD-106",
      fields: {
        summary: "Create Backend Endpoint for Fetching Approved Reviews",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20788",
      key: "OD-114",
      fields: {
        summary: "Integrate Backend Data with Analytics Dashboard",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20787",
      key: "OD-113",
      fields: {
        summary: "Design Analytics Dashboard UI",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20786",
      key: "OD-112",
      fields: {
        summary: "Integrate Sentiment Analysis for Reviews",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "20785",
      key: "OD-111",
      fields: {
        summary: "Backend System for Review Data Aggregation",
        issuetype: {
          id: "20080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "20784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21109",
      key: "OD-115",
      fields: {
        summary: "Performance Issue with Search Functionality",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21110",
      key: "OD-116",
      fields: {
        summary: "Performance Issue with Search Functionality",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21145",
      key: "OD-119",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21146",
      key: "OD-120",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21147",
      key: "OD-121",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21144",
      key: "OD-118",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21181",
      key: "OD-123",
      fields: {
        summary: "Urgent: Issue with Account Login",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21182",
      key: "OD-124",
      fields: {
        summary: "Urgent: Issue with Account Login",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21180",
      key: "OD-122",
      fields: {
        summary: "Issue with Account Login",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21183",
      key: "OD-125",
      fields: {
        summary: "Test Ticket for Zendesk Functionality",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21184",
      key: "OD-126",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Causing Unexpected Data Re-rendering",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21185",
      key: "OD-127",
      fields: {
        summary: "Urgent: Test Ticket for Zendesk Functionality",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21186",
      key: "OD-128",
      fields: {
        summary: "Authentication issue in outlook",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21187",
      key: "OD-129",
      fields: {
        summary: "Urgent: Test Ticket - System Email Notification Failure",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21188",
      key: "OD-130",
      fields: {
        summary: "Urgent: Test Ticket",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21189",
      key: "OD-131",
      fields: {
        summary: "Inability to Login to Outlook",
        issuetype: {
          id: "20076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21190",
      key: "OD-132",
      fields: {
        summary: "Critical Bug in Dashboard UI Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21191",
      key: "OD-133",
      fields: {
        summary: "Critical Bug in Dashboard UI Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21291",
      key: "OD-135",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21400",
      key: "OD-136",
      fields: {
        summary: "Improve UI/UX and Navigation Structure",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21401",
      key: "OD-137",
      fields: {
        summary: "Resolve Technical Glitches and Enhance System Performance",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21402",
      key: "OD-138",
      fields: {
        summary:
          "Enhance Feature & Functionality: Improved Filtering and Reporting",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "20768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "20070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "20079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21403",
      key: "OD-139",
      fields: {
        summary: "Improve Customer Support Process and Documentation",
        issuetype: {
          id: "20078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "21487",
      key: "OD-140",
      fields: {
        summary: "Dashboard UI Bug Affecting Client Experience",
        issuetype: {
          id: "20077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "20070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
  ],
};

const backlogIssues = {
  name: "Backlog",
  type: "backlog",
  id: generatedId(),
  noOfissues: 45,
  issues: [
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10612",
      key: "OD-1",
      fields: {
        summary: "User Authentication and Authorization",
        issuetype: {
          id: "10079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10625",
      key: "OD-14",
      fields: {
        summary: "Password Reset",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10612",
          key: "OD-1",
          fields: {
            summary: "User Authentication and Authorization",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "In Progress",
          id: "10071",
          statusCategory: {
            id: 4,
            key: "indeterminate",
            colorName: "yellow",
            name: "In Progress",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10618",
      key: "OD-7",
      fields: {
        summary: "Implement Confirmation Email",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10613",
          key: "OD-2",
          fields: {
            summary: "User Registration",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "In Progress",
          id: "10071",
          statusCategory: {
            id: 4,
            key: "indeterminate",
            colorName: "yellow",
            name: "In Progress",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10617",
      key: "OD-6",
      fields: {
        summary: "Implement Email Duplicate Check",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10613",
          key: "OD-2",
          fields: {
            summary: "User Registration",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10616",
      key: "OD-5",
      fields: {
        summary: "Implement Password Strength Validation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10613",
          key: "OD-2",
          fields: {
            summary: "User Registration",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "In Progress",
          id: "10071",
          statusCategory: {
            id: 4,
            key: "indeterminate",
            colorName: "yellow",
            name: "In Progress",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10614",
      key: "OD-3",
      fields: {
        summary: "Implement Registration Form UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10613",
          key: "OD-2",
          fields: {
            summary: "User Registration",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10615",
      key: "OD-4",
      fields: {
        summary: "Implement Email Format Validation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10613",
          key: "OD-2",
          fields: {
            summary: "User Registration",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10624",
      key: "OD-13",
      fields: {
        summary: "Implement Brute Force Protection",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10619",
          key: "OD-8",
          fields: {
            summary: "User Login",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10623",
      key: "OD-12",
      fields: {
        summary: "Implement Secure HTTPS for Login",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10619",
          key: "OD-8",
          fields: {
            summary: "User Login",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10622",
      key: "OD-11",
      fields: {
        summary: "Implement Error Handling and Feedback",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10619",
          key: "OD-8",
          fields: {
            summary: "User Login",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10621",
      key: "OD-10",
      fields: {
        summary: "Implement Credential Validation Logic",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10619",
          key: "OD-8",
          fields: {
            summary: "User Login",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10620",
      key: "OD-9",
      fields: {
        summary: "Implement Login Form UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10619",
          key: "OD-8",
          fields: {
            summary: "User Login",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10630",
      key: "OD-19",
      fields: {
        summary: "Test Password Reset Flow",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10625",
          key: "OD-14",
          fields: {
            summary: "Password Reset",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10629",
      key: "OD-18",
      fields: {
        summary: "Implement Password Validation Logic",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10625",
          key: "OD-14",
          fields: {
            summary: "Password Reset",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10628",
      key: "OD-17",
      fields: {
        summary: "Implement Password Reset Page",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10625",
          key: "OD-14",
          fields: {
            summary: "Password Reset",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10627",
      key: "OD-16",
      fields: {
        summary: "Generate and Send Password Reset Email",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10625",
          key: "OD-14",
          fields: {
            summary: "Password Reset",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10626",
      key: "OD-15",
      fields: {
        summary: "Implement Password Reset Request Form",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10625",
          key: "OD-14",
          fields: {
            summary: "Password Reset",
            status: {
              description: "",
              name: "In Progress",
              id: "10071",
              statusCategory: {
                id: 4,
                key: "indeterminate",
                colorName: "yellow",
                name: "In Progress",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10636",
      key: "OD-25",
      fields: {
        summary: "Implement Admin Activity Logging for Auditing",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10631",
          key: "OD-20",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10635",
      key: "OD-24",
      fields: {
        summary: "Implement Admin Permissions for Sensitive Operations",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10631",
          key: "OD-20",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10634",
      key: "OD-23",
      fields: {
        summary: "Design and Implement Admin Panel UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10631",
          key: "OD-20",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10633",
      key: "OD-22",
      fields: {
        summary: "Implement Admin Login and Access Control",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10631",
          key: "OD-20",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10632",
      key: "OD-21",
      fields: {
        summary: "Implement Admin Role Creation during User Registration",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10631",
          key: "OD-20",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10642",
      key: "OD-31",
      fields: {
        summary: "Implement Vendor Dashboard UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10637",
          key: "OD-26",
          fields: {
            summary: "Role-Based Access Control (Vendor)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "In Progress",
          id: "10071",
          statusCategory: {
            id: 4,
            key: "indeterminate",
            colorName: "yellow",
            name: "In Progress",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10641",
      key: "OD-30",
      fields: {
        summary: "Implement Vendor Order Management Features",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10637",
          key: "OD-26",
          fields: {
            summary: "Role-Based Access Control (Vendor)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10640",
      key: "OD-29",
      fields: {
        summary: "Implement Product Management Features for Vendor Dashboard",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10637",
          key: "OD-26",
          fields: {
            summary: "Role-Based Access Control (Vendor)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10639",
      key: "OD-28",
      fields: {
        summary: "Implement Vendor Dashboard Access Control",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10637",
          key: "OD-26",
          fields: {
            summary: "Role-Based Access Control (Vendor)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10638",
      key: "OD-27",
      fields: {
        summary: "Implement Vendor Role Creation during Registration",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10637",
          key: "OD-26",
          fields: {
            summary: "Role-Based Access Control (Vendor)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "In Progress",
          id: "10071",
          statusCategory: {
            id: 4,
            key: "indeterminate",
            colorName: "yellow",
            name: "In Progress",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10643",
      key: "OD-32",
      fields: {
        summary: "Product Catalog Management",
        issuetype: {
          id: "10079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10730",
      key: "OD-56",
      fields: {
        summary: "Product Categorization",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10643",
          key: "OD-32",
          fields: {
            summary: "Product Catalog Management",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10719",
      key: "OD-45",
      fields: {
        summary: "Product Filtering and Sorting",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10643",
          key: "OD-32",
          fields: {
            summary: "Product Catalog Management",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10644",
      key: "OD-33",
      fields: {
        summary: "Admin Product Creation",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10643",
          key: "OD-32",
          fields: {
            summary: "Product Catalog Management",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10649",
      key: "OD-38",
      fields: {
        summary: "Test Admin Product Creation Process",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10644",
          key: "OD-33",
          fields: {
            summary: "Admin Product Creation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10648",
      key: "OD-37",
      fields: {
        summary: "Implement Unique Product Identifiers (SKU) Feature",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10644",
          key: "OD-33",
          fields: {
            summary: "Admin Product Creation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10647",
      key: "OD-36",
      fields: {
        summary: "Implement Product Image Upload Feature",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10644",
          key: "OD-33",
          fields: {
            summary: "Admin Product Creation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10646",
      key: "OD-35",
      fields: {
        summary: "Implement Product Categorization Feature",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10644",
          key: "OD-33",
          fields: {
            summary: "Admin Product Creation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10645",
      key: "OD-34",
      fields: {
        summary: "Implement Admin Product Creation Form",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10644",
          key: "OD-33",
          fields: {
            summary: "Admin Product Creation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10655",
      key: "OD-44",
      fields: {
        summary: "Test Product Search Functionality",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10650",
          key: "OD-39",
          fields: {
            summary: "Product Search Functionality",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10654",
      key: "OD-43",
      fields: {
        summary: "Implement Sorting Options",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10650",
          key: "OD-39",
          fields: {
            summary: "Product Search Functionality",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10653",
      key: "OD-42",
      fields: {
        summary: "Implement Filtering by Attributes",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10650",
          key: "OD-39",
          fields: {
            summary: "Product Search Functionality",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10652",
      key: "OD-41",
      fields: {
        summary: "Implement Search Results Ranking",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10650",
          key: "OD-39",
          fields: {
            summary: "Product Search Functionality",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10651",
      key: "OD-40",
      fields: {
        summary: "Implement Search Bar",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10650",
          key: "OD-39",
          fields: {
            summary: "Product Search Functionality",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10724",
      key: "OD-50",
      fields: {
        summary: "Test Filtering and Sorting Functionality",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10719",
          key: "OD-45",
          fields: {
            summary: "Product Filtering and Sorting",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10723",
      key: "OD-49",
      fields: {
        summary: "Optimize Filtering and Sorting for Performance",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10719",
          key: "OD-45",
          fields: {
            summary: "Product Filtering and Sorting",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10722",
      key: "OD-48",
      fields: {
        summary: "Implement Dynamic Filtering and Sorting",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10719",
          key: "OD-45",
          fields: {
            summary: "Product Filtering and Sorting",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10721",
      key: "OD-47",
      fields: {
        summary: "Implement Sorting Options",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10719",
          key: "OD-45",
          fields: {
            summary: "Product Filtering and Sorting",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10720",
      key: "OD-46",
      fields: {
        summary: "Implement Product Filters",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10719",
          key: "OD-45",
          fields: {
            summary: "Product Filtering and Sorting",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10729",
      key: "OD-55",
      fields: {
        summary: "Test Image Upload and Display",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10725",
          key: "OD-51",
          fields: {
            summary: "Product Image Handling",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10728",
      key: "OD-54",
      fields: {
        summary: "Implement Image Display on Product Pages",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10725",
          key: "OD-51",
          fields: {
            summary: "Product Image Handling",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10727",
      key: "OD-53",
      fields: {
        summary: "Implement Image Resizing and Optimization",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10725",
          key: "OD-51",
          fields: {
            summary: "Product Image Handling",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10726",
      key: "OD-52",
      fields: {
        summary: "Implement Image Upload Form",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10725",
          key: "OD-51",
          fields: {
            summary: "Product Image Handling",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10734",
      key: "OD-60",
      fields: {
        summary: "Test Category Assignment and Display",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10730",
          key: "OD-56",
          fields: {
            summary: "Product Categorization",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10733",
      key: "OD-59",
      fields: {
        summary: "Implement Category-Based Filtering",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10730",
          key: "OD-56",
          fields: {
            summary: "Product Categorization",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10732",
      key: "OD-58",
      fields: {
        summary: "Display Categories on Product Pages",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10730",
          key: "OD-56",
          fields: {
            summary: "Product Categorization",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10731",
      key: "OD-57",
      fields: {
        summary: "Implement Category Assignment in Product Creation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10730",
          key: "OD-56",
          fields: {
            summary: "Product Categorization",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10735",
      key: "OD-61",
      fields: {
        summary: "Shopping Cart and Checkout",
        issuetype: {
          id: "10079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10631",
      key: "OD-20",
      fields: {
        summary: "Role-Based Access Control (Admin)",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10612",
          key: "OD-1",
          fields: {
            summary: "User Authentication and Authorization",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10757",
      key: "OD-83",
      fields: {
        summary: "Tax and Shipping Calculation",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10735",
          key: "OD-61",
          fields: {
            summary: "Shopping Cart and Checkout",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10746",
      key: "OD-72",
      fields: {
        summary: "Apply Discount or Coupon",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10735",
          key: "OD-61",
          fields: {
            summary: "Shopping Cart and Checkout",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10741",
      key: "OD-67",
      fields: {
        summary: "Modify Cart Contents",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10735",
          key: "OD-61",
          fields: {
            summary: "Shopping Cart and Checkout",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10736",
      key: "OD-62",
      fields: {
        summary: "Persistent Shopping Cart",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10735",
          key: "OD-61",
          fields: {
            summary: "Shopping Cart and Checkout",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10740",
      key: "OD-66",
      fields: {
        summary: "Testing for Cart Persistence and Synchronization",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10736",
          key: "OD-62",
          fields: {
            summary: "Persistent Shopping Cart",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10739",
      key: "OD-65",
      fields: {
        summary: "Implement Cart Synchronization Across Devices",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10736",
          key: "OD-62",
          fields: {
            summary: "Persistent Shopping Cart",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10738",
      key: "OD-64",
      fields: {
        summary: "Frontend Integration for Cart Operations",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10736",
          key: "OD-62",
          fields: {
            summary: "Persistent Shopping Cart",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10737",
      key: "OD-63",
      fields: {
        summary: "Implement Backend Logic for Cart Persistence",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10736",
          key: "OD-62",
          fields: {
            summary: "Persistent Shopping Cart",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10745",
      key: "OD-71",
      fields: {
        summary: "Testing for Cart Modification Functionality",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10741",
          key: "OD-67",
          fields: {
            summary: "Modify Cart Contents",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10744",
      key: "OD-70",
      fields: {
        summary: "Real-Time Cart Totals and Tax Recalculation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10741",
          key: "OD-67",
          fields: {
            summary: "Modify Cart Contents",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10743",
      key: "OD-69",
      fields: {
        summary: "Frontend UI for Cart Modification",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10741",
          key: "OD-67",
          fields: {
            summary: "Modify Cart Contents",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10742",
      key: "OD-68",
      fields: {
        summary: "Backend Logic for Cart Updates",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10741",
          key: "OD-67",
          fields: {
            summary: "Modify Cart Contents",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10750",
      key: "OD-76",
      fields: {
        summary: "Testing Coupon Application",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10749",
      key: "OD-75",
      fields: {
        summary: "Discount Calculation and Cart Update",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10748",
      key: "OD-74",
      fields: {
        summary: "Frontend UI for Coupon Application",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10747",
      key: "OD-73",
      fields: {
        summary: "Backend Validation for Coupons",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10746",
          key: "OD-72",
          fields: {
            summary: "Apply Discount or Coupon",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10756",
      key: "OD-82",
      fields: {
        summary: "Testing Payment Integration",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10755",
      key: "OD-81",
      fields: {
        summary: "Order Confirmation Page",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10754",
      key: "OD-80",
      fields: {
        summary: "Secure Payment Processing Backend",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10753",
      key: "OD-79",
      fields: {
        summary: "Frontend Payment Options UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10752",
      key: "OD-78",
      fields: {
        summary: "Integrate Payment Gateway APIs",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10751",
          key: "OD-77",
          fields: {
            summary: "Checkout Payment Gateway Integration",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10761",
      key: "OD-87",
      fields: {
        summary: "Testing Tax and Shipping Calculation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10760",
      key: "OD-86",
      fields: {
        summary: "Dynamic Fee Update on Address Change",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10759",
      key: "OD-85",
      fields: {
        summary: "Shipping Fee Calculation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10758",
      key: "OD-84",
      fields: {
        summary: "Tax Calculation Logic",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10757",
          key: "OD-83",
          fields: {
            summary: "Tax and Shipping Calculation",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10762",
      key: "OD-88",
      fields: {
        summary: "Order Management System",
        issuetype: {
          id: "10079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10763",
      key: "OD-89",
      fields: {
        summary: "Role-Based Access Control (Admin)",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10762",
          key: "OD-88",
          fields: {
            summary: "Order Management System",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10767",
      key: "OD-93",
      fields: {
        summary: "Logging Admin Actions",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10766",
      key: "OD-92",
      fields: {
        summary: "Restrict Admin Panel Access",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10765",
      key: "OD-91",
      fields: {
        summary: "Create Admin Panel UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10764",
      key: "OD-90",
      fields: {
        summary: "Define Role Management Logic",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10763",
          key: "OD-89",
          fields: {
            summary: "Role-Based Access Control (Admin)",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10768",
      key: "OD-94",
      fields: {
        summary: "Customer Feedback and Review System",
        issuetype: {
          id: "10079",
          description:
            "Epics track collections of related bugs, stories, and tasks.",
          name: "Epic",
          subtask: false,
          avatarId: 10307,
          entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
          hierarchyLevel: 1,
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10784",
      key: "OD-110",
      fields: {
        summary: "Review Analytics for Insights",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10779",
      key: "OD-105",
      fields: {
        summary: "Display Approved Reviews",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10774",
      key: "OD-100",
      fields: {
        summary: "Review Moderation by Admin",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10769",
      key: "OD-95",
      fields: {
        summary: "Customer Review Submission",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10773",
      key: "OD-99",
      fields: {
        summary: "Handle Review Confirmation and Error Messaging",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10772",
      key: "OD-98",
      fields: {
        summary: "Integrate Review System with Product Pages",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10771",
      key: "OD-97",
      fields: {
        summary: "Design and Implement Review Submission UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10770",
      key: "OD-96",
      fields: {
        summary: "Implement Review Submission Backend",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10769",
          key: "OD-95",
          fields: {
            summary: "Customer Review Submission",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10778",
      key: "OD-104",
      fields: {
        summary: "Add Notification for Moderation Results",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10777",
      key: "OD-103",
      fields: {
        summary: "Integrate Moderation Actions with Logging System",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10776",
      key: "OD-102",
      fields: {
        summary: "Create Review Moderation UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10775",
      key: "OD-101",
      fields: {
        summary: "Implement Review Moderation Backend",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10774",
          key: "OD-100",
          fields: {
            summary: "Review Moderation by Admin",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10783",
      key: "OD-109",
      fields: {
        summary: "Add Review Sorting Options",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10782",
      key: "OD-108",
      fields: {
        summary: "Integrate Backend API with Frontend for Review Display",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10781",
      key: "OD-107",
      fields: {
        summary: "Design Frontend UI for Review Display",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10780",
      key: "OD-106",
      fields: {
        summary: "Create Backend Endpoint for Fetching Approved Reviews",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10779",
          key: "OD-105",
          fields: {
            summary: "Display Approved Reviews",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10788",
      key: "OD-114",
      fields: {
        summary: "Integrate Backend Data with Analytics Dashboard",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10787",
      key: "OD-113",
      fields: {
        summary: "Design Analytics Dashboard UI",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:2f9c719e-9dbe-4eab-a839-77f85ebc5b38",
          displayName: "ADITYA SHARMA",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10786",
      key: "OD-112",
      fields: {
        summary: "Integrate Sentiment Analysis for Reviews",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "10785",
      key: "OD-111",
      fields: {
        summary: "Backend System for Review Data Aggregation",
        issuetype: {
          id: "10080",
          description:
            "Subtasks track small pieces of work that are part of a larger task.",
          name: "Subtask",
          subtask: true,
          avatarId: 10316,
          entityId: "6448daee-6b33-49b8-a98d-580a9e027215",
          hierarchyLevel: -1,
        },
        parent: {
          id: "10784",
          key: "OD-110",
          fields: {
            summary: "Review Analytics for Insights",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10078",
              description:
                "Stories track functionality or features expressed as user goals.",
              name: "Story",
              subtask: false,
              avatarId: 10315,
              entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
              hierarchyLevel: 0,
            },
          },
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11109",
      key: "OD-115",
      fields: {
        summary: "Performance Issue with Search Functionality",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: {
          accountId: "712020:7c2d2187-3e7e-4efd-9c9b-de3e41646aba",
          emailAddress: "choudharysarthak124@gmail.com",
          displayName: "Sarthak Choudhary",
          active: true,
          timeZone: "Asia/Calcutta",
          accountType: "atlassian",
        },
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11110",
      key: "OD-116",
      fields: {
        summary: "Performance Issue with Search Functionality",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11145",
      key: "OD-119",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11146",
      key: "OD-120",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11147",
      key: "OD-121",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11144",
      key: "OD-118",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11181",
      key: "OD-123",
      fields: {
        summary: "Urgent: Issue with Account Login",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11182",
      key: "OD-124",
      fields: {
        summary: "Urgent: Issue with Account Login",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11180",
      key: "OD-122",
      fields: {
        summary: "Issue with Account Login",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11183",
      key: "OD-125",
      fields: {
        summary: "Test Ticket for Zendesk Functionality",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11184",
      key: "OD-126",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Causing Unexpected Data Re-rendering",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11185",
      key: "OD-127",
      fields: {
        summary: "Urgent: Test Ticket for Zendesk Functionality",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11186",
      key: "OD-128",
      fields: {
        summary: "Authentication issue in outlook",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11187",
      key: "OD-129",
      fields: {
        summary: "Urgent: Test Ticket - System Email Notification Failure",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11188",
      key: "OD-130",
      fields: {
        summary: "Urgent: Test Ticket",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11189",
      key: "OD-131",
      fields: {
        summary: "Inability to Login to Outlook",
        issuetype: {
          id: "10076",
          description: "Tasks track small, distinct pieces of work.",
          name: "Task",
          subtask: false,
          avatarId: 10318,
          entityId: "a6d82025-c44c-4e8d-b456-c093a8289ed9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11190",
      key: "OD-132",
      fields: {
        summary: "Critical Bug in Dashboard UI Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11191",
      key: "OD-133",
      fields: {
        summary: "Critical Bug in Dashboard UI Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11291",
      key: "OD-135",
      fields: {
        summary:
          "Critical Bug: Dashboard UI Glitches Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11400",
      key: "OD-136",
      fields: {
        summary: "Improve UI/UX and Navigation Structure",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11401",
      key: "OD-137",
      fields: {
        summary: "Resolve Technical Glitches and Enhance System Performance",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11402",
      key: "OD-138",
      fields: {
        summary:
          "Enhance Feature & Functionality: Improved Filtering and Reporting",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        parent: {
          id: "10768",
          key: "OD-94",
          fields: {
            summary: "Customer Feedback and Review System",
            status: {
              description: "",
              name: "To Do",
              id: "10070",
              statusCategory: {
                id: 2,
                key: "new",
                colorName: "blue-gray",
                name: "To Do",
              },
            },
            priority: {
              name: "Medium",
              id: "3",
            },
            issuetype: {
              id: "10079",
              description:
                "Epics track collections of related bugs, stories, and tasks.",
              name: "Epic",
              subtask: false,
              avatarId: 10307,
              entityId: "ce8160bf-ee9e-4fce-a218-afcde77daf40",
              hierarchyLevel: 1,
            },
          },
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11403",
      key: "OD-139",
      fields: {
        summary: "Improve Customer Support Process and Documentation",
        issuetype: {
          id: "10078",
          description:
            "Stories track functionality or features expressed as user goals.",
          name: "Story",
          subtask: false,
          avatarId: 10315,
          entityId: "abd13ea0-2ddb-4bc0-8bac-a93190ff7e7f",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
    {
      expand:
        "operations,versionedRepresentations,editmeta,changelog,renderedFields",
      id: "11487",
      key: "OD-140",
      fields: {
        summary: "Dashboard UI Bug Affecting Client Experience",
        issuetype: {
          id: "10077",
          description: "Bugs track problems or errors.",
          name: "Bug",
          subtask: false,
          avatarId: 10303,
          entityId: "0c9c69bf-5382-4a09-b39c-d223111b6ea9",
          hierarchyLevel: 0,
        },
        assignee: null,
        status: {
          description: "",
          name: "To Do",
          id: "10070",
          statusCategory: {
            id: 2,
            key: "new",
            colorName: "blue-gray",
            name: "To Do",
          },
        },
      },
    },
  ],
};

export const fullData = [sprintIssues, backlogIssues];
export const structuredData = [
  { ...sprintIssues, issues: filterIssue(sprintIssues.issues) },
  { ...backlogIssues, issues: filterIssue(backlogIssues.issues) },
];